import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row} from 'reactstrap';
import {Formik, Form, Field} from 'formik';

const fromCrontab = (crontab) => {
    const [second, minute, hour, dayOfMonth, month, dayOfWeek] = crontab.split(' ', 6);
    return {second, minute, hour, dayOfMonth, month, dayOfWeek};
};

const toCrontab = ({second, minute, hour, dayOfMonth, month, dayOfWeek}) => `${second} ${minute} ${hour} ${dayOfMonth} ${month} ${dayOfWeek}`;

class CrontabEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    handleSubmit(values) {
        this.props.onSubmit(toCrontab(values));
        this.setState({modal: false});
    }

    render() {
        const {crontab} = this.props;
        return (
            <>
                <pre onClick={this.toggleModal}>{crontab}</pre>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <Formik initialValues={fromCrontab(crontab)} onSubmit={this.handleSubmit}>
                        <Form>
                            <ModalHeader toggle={this.toggleModal}>Edit crontab</ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_hour">Hour (0-23)</label>
                                        <Field type="text" id="crontab_hour" name="hour" className="form-control" placeholder="Hour" required />
                                    </Col>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_minute">Minute (0-59)</label>
                                        <Field type="text" id="crontab_minute" name="minute" className="form-control" placeholder="Minute" required />
                                    </Col>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_second">Second (0-59)</label>
                                        <Field type="text" id="crontab_second" name="second" className="form-control" placeholder="Second" required />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_dayOfMonth">Day (1-31)</label>
                                        <Field type="text" id="crontab_dayOfMonth" name="dayOfMonth" className="form-control" placeholder="Day" required />
                                    </Col>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_month">Month (1-12)</label>
                                        <Field type="text" id="crontab_month" name="month" className="form-control" placeholder="Month" required />
                                    </Col>
                                    <Col className="form-group">
                                        <label htmlFor="crontab_dayOfWeek">Day of week (0-7)</label>
                                        <Field type="text" id="crontab_dayOfWeek" name="dayOfWeek" className="form-control" placeholder="Day of week"
                                            required />
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                                <Button type="submit" color="primary" onClick={this.toggleModal}>OK</Button>{' '}
                            </ModalFooter>
                        </Form>
                    </Formik>
                </Modal>
            </>
        );
    }
}

export default CrontabEditor;
